import { FC } from 'react';
import { useTranslation, Trans } from 'next-i18next';
import {
  GMB_GOOGLE_MAPS_ADDRESS,
  SUPPORT_URLS,
  WORK_WITH_US_EMAIL,
} from 'src/common/constants';
import PitchPageLayout from 'src/common/components/PitchPageLayout';
import Typography from 'src/common/components/Typography';
import PitchPageResource, { PitchPageResourceProps } from 'src/common/components/PitchPageResource';
import UniversalLink from 'src/common/components/UniversalLink';
import styles from './Resources.module.scss';

const Resources: FC = () => {
  const [t] = useTranslation('contact-us');

  const resourceListItems: PitchPageResourceProps[] = [
    {
      iconId: 'question',
      iconColor: 'sand',
      title: t('resource--0--title'),
      text: t('resource--0--text'),
      linkText: t('resource--0--link'),
      linkHref: SUPPORT_URLS.HELP_CENTER,
    },
    {
      iconId: 'hand-heart',
      iconColor: 'sunset',
      title: t('resource--1--title'),
      text: t('resource--1--text'),
      linkText: WORK_WITH_US_EMAIL,
      linkHref: `mailto: ${WORK_WITH_US_EMAIL}`,
      withLinkArrow: false,
      withNewTabAttributes: false,
    },
  ];

  return (
    <PitchPageLayout backgroundColor="pearl">
      <div className={styles.root}>
        <div className={styles.title}>
          <Typography
            type="h2"
            size="display-4"
          >
            {t('resources--title')}
          </Typography>
        </div>
        <ul className={styles.resourceList}>
          {resourceListItems.map((item) => (
            <PitchPageResource
              key={item.title}
              {...item}
              colorVariant="midnight-01"
              textSize="body-xl"
            />
          ))}
        </ul>
        <address className={styles.address}>
          <UniversalLink
            href={GMB_GOOGLE_MAPS_ADDRESS}
            openInNewTab
          >
            <Typography
              type="p"
              size="body-xl"
            >
              <Trans
                t={t}
                i18nKey="address"
                components={{
                  break: <br />,
                }}
              />
            </Typography>
          </UniversalLink>
        </address>
      </div>
    </PitchPageLayout>
  );
};

export default Resources;
